import { lazy } from 'react'

export default {
    path: '/tipologie-documento',
    title: 'Tipologie documento',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:tipologiaDocumentoId',
            title: 'Tipologia documento: {{params.tipologiaDocumentoId}}',
            drawer: false,
            component: lazy(() => import('./detail'))
        }
    ]
}